import { render, staticRenderFns } from "./PageColumn.vue?vue&type=template&id=18c379a8&"
import script from "./PageColumn.vue?vue&type=script&lang=js&"
export * from "./PageColumn.vue?vue&type=script&lang=js&"
import style0 from "./PageColumn.vue?vue&type=style&index=0&id=18c379a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports